import { Row, Form, Button, Table, Tag, Space } from 'antd'
import styled from 'styled-components'
import { PlusOutlined, LeftOutlined,SaveOutlined,CheckCircleOutlined } from '@ant-design/icons'
import React, { useState, useEffect } from 'react'
import { getCookie } from 'helper/cookie'
import { getResultProjectList } from '../../../api/Project/sprintFlow'
import '../../../styleLess/signature/sprintTaskFlow.scss'

const Container2 = styled.div`
  background: #ffffff;
  background-color: white;
  width: 100%;
  height: auto;

  .font-button {
    font-family: IBMPlexSansThaiRegular;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
  }
`

const idEditPRJ = getCookie('idPRJ')

const initalState = {
  data: [],
  isLoading: true,
}

const SprintTaskFlow = (props) => {
  const { swithCaseTaskFLowFunction } = props
  const onFinish = (values) => {
  }

  const [data, setData] = useState(initalState.data)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const getCardlistData = async () => {
    await getResultProjectList({
      project_id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setData([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setData(data)
          await setIsLoading(false)
        } else {
          setData([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setData([])
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getCardlistData()
      return () => {
        getCardlistData()
      }
    }
  }, [token])

  const dataSource2 = data.map((item) => ({
    key: item.id,
    name: item.title,
    plannedStart: item.plan_start,
    plannedEnd: item.plan_end,
    subTask: item.count_sub,
    status: [item.status],
  }))
  const columns = [
    {
      title: 'Sprint Name',
      dataIndex: 'name',
      key: 'name',
      width: 250,
    },
    {
      title: 'Planned date',
      dataIndex: 'plannedDate',
      key: 'plannedDate',
      width: 250,
      render: (text,record) => {
        return (
          <Space>
            <p>{record.plannedStart} - {record.plannedEnd}</p>
          </Space>
        )
      },
    },
    {
      title: 'Sub Task',
      dataIndex: 'subTask',
      key: 'subTask',
      width: 100,
      align: 'center',
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',

      align: 'center',
      render: (status) => (
        <>
          {status.map((tag) => {
            let color = 'yellow'
            if (tag === 'Active') {
              color = 'blue'
            }
            return (
              <Tag color={color} key={tag}>
                {tag}
              </Tag>
            )
          })}
        </>
      ),
    },
  ]

  return (
    <Container2>
      <div className="DraftandRegis-Container">
        <div className="absolute">
          <Button className="BTN_ClassA">
            <SaveOutlined className="Icon-color" />
            Save Draft
          </Button>
          <Button className="BTN_Next" disabled={false}>
            <CheckCircleOutlined className="Icon-color" />
            Register
          </Button>
        </div>
      </div>
      <div>
        <Form name="register_step6" onFinish={onFinish}>
          <h2>Sprint(Task) Flow</h2>
          <Row style={{ justifyContent: 'flex-end', marginTop: -40 }}>
            <Button
              className="BTN_ClassA"
              onClick={() => swithCaseTaskFLowFunction('addtask')}
            >
              <PlusOutlined className="Icon-color" />
              Add Task
            </Button>
          </Row>

          <Table
            className="Table tablesprinttask "
            style={{ marginTop: 24 }}
            dataSource={dataSource2}
            columns={columns}
            pagination={false}
          />

          <Row justify="end" style={{ marginTop: 64 }}>
            <Button
              type="primary"
              className="BTN_Previous"
              style={{ marginRight: 8 }}
              onClick={() => swithCaseTaskFLowFunction('supportneed')}
            >
              <LeftOutlined className="Icon-color" />
              Previous
            </Button>
          </Row>
        </Form>
      </div>
    </Container2>
  )
}

export default SprintTaskFlow
